import React, { Fragment, useState, useEffect } from 'react';
import Modal from '@material-ui/core/Modal';
import { Col, Button, Row } from 'reactstrap';
import { reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import BasicTable from './BasicTable';
import moment from 'moment';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import InfoPatient from '../../../ClinicHistory/SearchClinicHistory/components/InfoPatient';

const TenCorrectAdmission = ({ data, openTenCorrect, setOpenTenCorrect, callbackTenCorrect }) => {
  const [answers, setAnswers] = useState(['', '', '', '', '', '', '', '', '', '']);
  const [disabled, setDisabled] = useState(false);
  const [loading, setLoading] = useState(true);
  const [medicamet, setMedicamet] = useState(['', '', '', '']);
  const [radio1, setRadio1] = useState({ question: 'PACIENTE CORRECTO', answer: null });
  const [radio2, setRadio2] = useState({ question: 'PROCEDIMIENTO CORRECTO SOLICITADO', answer: null });
  const [radio3, setRadio3] = useState({ question: 'a. Cumple con los requerimientos del examen', answer: null });
  const [radio4, setRadio4] = useState({ question: 'b. Suspension Medicamento', answer: null });
  const [radio5, setRadio5] = useState({ question: 'c. Otros', answer: null });
  const [radio6, setRadio6] = useState({ question: 'REQUIERE ALGUN MEDICAMENTO PARA EL EXAMEN', answer: null });
  const [radio7, setRadio7] = useState({ question: 'MEDICAMENTO CORRECTO', answer: null });
  const [radio8, setRadio8] = useState({ question: 'VIA DE ADMINISTRACIÓN CORRECTA', answer: null });
  const [radio9, setRadio9] = useState({ question: 'DOSIS', answer: null });
  const [radio10, setRadio10] = useState({ question: 'MOMENTO U HORARIO CORRECTO', answer: null });
  const [radio11, setRadio11] = useState({ question: 'INFORMAR AL PACIENTE LA NECESIDAD DEL USO DEL MEDICAMENTO', answer: null });
  const [radio12, setRadio12] = useState({ question: 'SE INFORMARON POSIBLES EFECTOS SECUNDARIOS', answer: null });
  const [observacion, setObservacion] = useState('');

  useEffect(() => {
    if(data.original.id_admision_cita_padre !== null && data.original.id_admision_cita_padre !== undefined ){
      loadTenCorrect(data.original.id_admision_cita_padre, data.original.id_historia);
    }else{
      loadTenCorrect(data.original.id_admision, data.original.id_historia);
    }
  }, []);

  const loadTenCorrect = (id_admision, id_historia) => {
    var dataSend = {
      id_historia: parseInt(id_historia),
      id_admision: parseInt(id_admision)
    };

    console.log(dataSend);
    fetch(process.env.REACT_APP_PUBLIC_URL + 'correctos/consultar', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
      },
      body: JSON.stringify(dataSend)
    })
      .then(response => {
        return response.json();
      })
      .then(data => {
        console.log(data);
        if (data.existe) {
          if (data.contenido[0].correctos != null) {
            setRadio1({ ...radio1, answer: data.contenido[0].correctos.correctos.paciente });
            setRadio2({ ...radio2, answer: data.contenido[0].correctos.correctos.procedimiento })
            setRadio3({ ...radio3, answer: data.contenido[0].correctos.correctos.req_examen })
            setRadio4({ ...radio4, answer: data.contenido[0].correctos.correctos.suspencion_medicamento })
            setRadio5({ ...radio5, answer: data.contenido[0].correctos.correctos.otros })
            setRadio6({ ...radio6, answer: data.contenido[0].correctos.correctos.requiere_medicamento })
            setRadio7({ ...radio7, answer: data.contenido[0].correctos.correctos.medicamento_correcto })
            setRadio8({ ...radio8, answer: data.contenido[0].correctos.correctos.via_administracion })
            setRadio9({ ...radio9, answer: data.contenido[0].correctos.correctos.dosis })
            setRadio10({ ...radio10, answer: data.contenido[0].correctos.correctos.momento })
            setRadio11({ ...radio11, answer: data.contenido[0].correctos.correctos.use_medicine })
            setRadio12({ ...radio12, answer: data.contenido[0].correctos.correctos.efectos_seg })
            setObservacion(data.contenido[0].correctos.correctos.observaciones)
            setDisabled(true);
            setLoading(false);
          } else {
            setLoading(false);
          }

        } else {
          setLoading(false);
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  const createTenCorrect = (data) => {

    if (radio1.answer !== null && radio2.answer !== null && radio3.answer !== null
      && radio4.answer !== null && radio5.answer !== null && radio6.answer !== null) {

      var correctos = {
        paciente: radio1.answer,
        procedimiento: radio2.answer,
        //req_examen: answers[2],
        req_examen: radio3.answer,
        suspencion_medicamento: radio4.answer,
        otros: radio5.answer,
        requiere_medicamento: radio6.answer,
        medicamento_correcto: radio7.answer,
        via_administracion: radio8.answer,
        dosis: radio9.answer,
        momento: radio10.answer,
        use_medicine: radio11.answer,
        efectos_seg: radio12.answer,
        observaciones: observacion,
        //medicamentos: medicamet,
        fecha_hora: moment(new Date()).format("DD-MM-YYYY HH:mm:ss")
      }

      let usuario = JSON.parse(sessionStorage.getItem('usuario'));

      var dataSend = {
        id_historia: data.original.id_historia.toString(),
        id_admision: data.original.id_admision.toString(),
        correctos: correctos,
        id_usuario: usuario.id_usuario
      };

      fetch(process.env.REACT_APP_PUBLIC_URL + 'correctos/create', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Bearer ' + sessionStorage.getItem('token'),
        },
        body: JSON.stringify(dataSend)
      })
        .then(response => {
          if (response.status != 500 && response.status != 403) {
            response.json();
            callbackTenCorrect(data.original.id_admision, correctos);
          } else {
            throw new Error("Error en el servidor")
          }
        })
        .then(data => {
          setDisabled(true);
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    } else {
      alert("No se ha llenado todos los datos requeridos");
    }
  }

  return (
    <Fragment>
      {!loading ? <Modal
        open={openTenCorrect}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        style={{ zIndex: 1000 }}
      >
        <div className="paperAppointment-flex" style={{ width: '100%', margin: 10, height: 600, overflowY: "auto" }}>
          <div className="card__title">
            <h4 className="bold-text">10 correctos</h4>
            <h5>Informacion a Verificar</h5>
          </div>
          
          <InfoPatient dataPatient={data.original}/>

          <div>
            <BasicTable data={data.original} answers={answers} setAnswers={setAnswers} medicamet={medicamet} setMedicamet={setMedicamet} disabled={disabled}
              radio1={radio1} setRadio1={setRadio1}
              radio2={radio2} setRadio2={setRadio2}
              radio3={radio3} setRadio3={setRadio3}
              radio4={radio4} setRadio4={setRadio4}
              radio5={radio5} setRadio5={setRadio5}
              radio6={radio6} setRadio6={setRadio6}
              radio7={radio7} setRadio7={setRadio7}
              radio8={radio8} setRadio8={setRadio8}
              radio9={radio9} setRadio9={setRadio9}
              radio10={radio10} setRadio10={setRadio10}
              radio11={radio11} setRadio11={setRadio11}
              radio12={radio12} setRadio12={setRadio12}
              observacion={observacion} setObservacion={setObservacion} />
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button
              style={{ marginTop: 10 }}
              color="primary"
              onClick={() => {
                setOpenTenCorrect(false);
              }}
            >
              Cerrar
            </Button>
            <Button
              disabled={disabled}
              style={{ marginTop: 10, marginRight: 10 }}
              color="primary"
              onClick={() => {
                createTenCorrect(data);
              }}
            >
              Aceptar
            </Button>
          </div>
        </div>
      </Modal> : <Modal
        open={openTenCorrect}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        style={{ zIndex: 1000 }}
      >
        <div style={{
          position: 'absolute',
          backgroundColor: '#ffffff',
          width: 200,
          height: 200,
          top: '50%',
          left: '50%',
          transform: 'translate(-50%,-50%)',
          display: 'flex'
        }}
        >
          <div className="load__icon-wrap">
            <svg className="load__icon">
              <path fill="#4ce1b6" d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z" />
            </svg>
          </div>
        </div>
        {/*<div class="load">
                              <div class="load__icon-wrap">
                                <svg class="load__icon">
                                  <path fill="#4ce1b6" d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z"/>
                                </svg>
                              </div>
                            </div>*/}
      </Modal>}
    </Fragment>)
}

export default reduxForm({
  form: `ten-correct-form`, // a unique identifier for this form
})(withTranslation('common')(TenCorrectAdmission));